import React from "react";
import { Card, CardHeader, CardTitle, CardBody } from "reactstrap";
import Content from "./Content";
import "./index.styles.scss";
import { translate } from "react-i18next";

class LocationDevices extends React.Component {
  render() {
    return (
      <Card className="card-default" style={{ height: "100%", width: "100%" }}>
        <CardHeader className="d-flex align-items-center justify-content-between card-header-border">
          <CardTitle>{this.props.t("dashboard.locationsDevices")}</CardTitle>
        </CardHeader>
        <div
          style={{
            height: "1px",
            width: "100%",
            background: "#ccc",
          }}
        />
        <CardBody style={{ overflow: "hidden", paddingBottom: "10px" }}>
          <Content {...this.props} />
        </CardBody>
      </Card>
    );
  }
}

export default translate("translations")(LocationDevices);
